import { Box, Tooltip } from '@mui/material'
import {
  AssignmentIcon as CustomAssignmentIcon,
  CorrectIcon,
} from 'src/v3/core/icons'

export let completeMarker = (
  <Box
    sx={{
      position: 'absolute',
      zIndex: 1,
      right: 3,
      top: 3,
      bgcolor: 'background.default',
      borderRadius: '50%',
    }}
  >
    <Tooltip title="You have completed this course" placement="top">
      <CorrectIcon
        sx={{
          mt: '-3px',
          mx: '1.5px',
          color: 'success.main',
        }}
      />
    </Tooltip>
  </Box>
)

export let assignedMarker = (
  <Box
    sx={{
      position: 'absolute',
      zIndex: 1,
      right: 3,
      top: 3,
      bgcolor: 'background.default',
      borderRadius: '50%',
    }}
  >
    <Tooltip title="You have been assigned this course" placement="top">
      <CustomAssignmentIcon
        sx={{
          mt: '-2px',
          mx: '1.5px',
          color: 'primary.main',
        }}
      />
    </Tooltip>
  </Box>
)
